import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import React, { useState } from 'react';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TagModal } from 'src/components/tags/TagModal';
import { sleep } from 'src/utils/sleep';
export const CompanyActionsMenu = observer(_ref => {
  var _store$homeDashboardS;
  let tags = _ref.tags,
    companyId = _ref.companyId,
    trigger = _ref.trigger,
    impersonateCallBackExt = _ref.impersonateCallBackExt,
    isImpersonateInProgress = _ref.isImpersonateInProgress;
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showTagModal = _useState4[0],
    setShowTagModal = _useState4[1];
  const handleShowTagModal = () => setShowTagModal(true);
  const handleCloseTagModal = () => setShowTagModal(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TagModal, {
    companyId: companyId,
    tags: tags,
    trigger: trigger,
    triggerButton: null,
    isOpen: showTagModal,
    handleClose: () => handleCloseTagModal()
  }), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('Company options'),
    key: 'company_selector_company_options_btn' + ((_store$homeDashboardS = store.homeDashboardStore) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.enableShortcutsHintState),
    placement: "top",
    type: "info"
    // open={store.homeDashboardStore?.enableShortcutsHintState || undefined}
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "company-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "company options menu",
    "data-menu": true,
    onClick: handleClick,
    state: open ? 'active' : undefined,
    size: "large",
    disabled: isImpersonateInProgress,
    'custom-attribute': '649-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot",
    "data-menu": true
  }))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "company-action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    "data-menu": true,
    variant: "menuAction",
    onClick: () => {
      impersonateCallBackExt(async () => {
        await sleep(1000);
        handleClose();
        navigate('/profile-settings?tab=company-details');
      });
    },
    'custom-attribute': '650-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('Edit company details')), /*#__PURE__*/React.createElement(Button, {
    "data-menu": true,
    onClick: () => {
      handleClose();
      handleShowTagModal();
    },
    variant: "menuAction",
    'custom-attribute': '651-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "tag"
  }), t('Add or remove tags')), /*#__PURE__*/React.createElement(Button, {
    "data-menu": true,
    variant: "menuAction",
    onClick: () => {
      impersonateCallBackExt(async () => {
        await sleep(1000);
        handleClose();
        navigate('/new_property');
      });
    },
    'custom-attribute': '652-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), t('Add property'))));
});